<template>
  <div class='animated fadeIn'>
    <b-row>
      <b-col md='6'>
        <b-card>
          <div slot='header'>
            <strong><i class="fa fa-align-justify"></i> Créer une nouvelle catégorie</strong>
          </div>

          <b-form-group
              description='Libelle de la catégorie'
              label='Libelle'
              label-for='Libelle'
            >
            <b-form-input id='libelle' type='text' :class="{hasError: errors.libelle !== ''}" v-model="libelle"></b-form-input>
            <span class='field-error'>{{ errors.libelle }}</span>
          </b-form-group>

          <b-form-group
              description='Libellé technique de la catégorie'
              label='Libelle technique'
              label-for='tec_label'
            >
            <b-form-input id='tec_label' type='text' :class="{hasError: errors.libelle_technique !== ''}" v-model="libelle_technique"></b-form-input>
            <span class='field-error'>{{ errors.libelle_technique }}</span>
          </b-form-group>
          <div slot="footer">
            <b-button type="button" @click="returnBack" size="md" variant="secondary">
              <i class="fa fa-arrow-left"></i> Liste des statuts
            </b-button>
            <b-button type="button" @click="add" size="md" class="pull-right" variant="primary">
              <i class="fa fa-save"></i> Enregistrer
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../../utils/auth'

export default {
  data() {
    return {
      libelle: '',
  	  libelle_technique: '',
      errors: {
        libelle: '',
        libelle_technique: ''
      }
    }
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken();
    this.$axios.defaults.headers.common['Accept'] = 'application/json';
    this.$axios.defaults.headers.common['Provider'] = getProvider();
  },
  methods: {
    add() {
      if (this.validateData()) {
        this.$store.commit('IS_LOADING', true)
        let self = this;
        let dataPost = {};
        dataPost.libelle = this.libelle;
        dataPost.libelle_technique = this.libelle_technique;
        this.$axios
          .post("/administration/categories", dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            this.$swal({ position: 'top', type: 'success', title:'Création avec succès', text:'La catégorie ' + dataPost.libelle + ' a bien été créé',showConfirmButton: false, timer: 5000})
            // On efface les données pour un nouvel enregistrement
            this.libelle = ''
            this.libelle_technique = ''
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({ position: 'top', type: 'error', title:'Attention !!', text:'Un problème est survenu, merci de contacter l\'administration',showConfirmButton: false, timer: 5000})
          });
      }
    },
    returnBack() {
      this.$router.push({ path: '/administration/statuts' })
    },
    validateData () {
      this.clearErrors();
      let regAlpha = this.$store.getters.getRegAlpha
      let regAlphaUnderscore = this.$store.getters.getRegAlphaUnderscore
      let valid = true
      
      if (this.libelle === '') {
        this.errors.libelle = 'Le libelle est obligatoire'
        valid= false;
      }

      if (this.libelle_technique === '') {
        this.errors.libelle_technique = 'Le libelle technique est obligatoire'
        valid= false
      }

      return valid;
    },
    clearErrors() {
      this.errors.libelle = '';
      this.errors.libelle_technique = '';
    }
  }
}
</script>

<style>

</style>
